"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compareForValidity = _interopRequireDefault(require("./compareForValidity"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getElementIsValid = function getElementIsValid(elementA, elementB) {
  var isValid = false;

  if (elementA && elementA instanceof HTMLElement) {
    // Reset custom validity messages;
    typeof elementA.setCustomValidity === "function" && elementA.setCustomValidity("");
    isValid = elementA.checkValidity();

    if (isValid && elementB && elementB instanceof HTMLElement) {
      isValid = (0, _compareForValidity.default)(elementA, elementB);
    }
  }

  return isValid;
};

var _default = getElementIsValid;
exports.default = _default;